import RoleBadge from "../Row/RoleBadge";

const MobileUserItem = ({ user, onEdit, onDelete }) => {
    return (
        <div className="p-4 space-y-3 bg-white">

            {/* Name + Role */}
            <div className="flex items-center justify-between">
                <div className="font-semibold text-gray-900 text-base">
                    {user.firstName} {user.lastName}
                </div>

                <RoleBadge role={user.role} />
            </div>

            {/* Phone */}
            <div className="text-gray-500 text-sm border-r-4 border-purple-300 pr-2">
                {user.phone}
            </div>

            {/* Actions */}
            <div className="flex gap-3 pt-2">

                <button
                    onClick={() => onEdit(user)}
                    className="
                        flex-1 py-2 
                        rounded-lg bg-blue-50 text-blue-700 
                        text-sm font-medium 
                        hover:bg-blue-100 
                        transition
                    "
                >
                    ویرایش
                </button>

                <button
                    onClick={() => onDelete(user)}
                    className="
                        flex-1 py-2 
                        rounded-lg bg-red-50 text-red-600 
                        text-sm font-medium 
                        hover:bg-red-100 
                        transition
                    "
                >
                    حذف
                </button>

            </div>

        </div>
    );
};

export default MobileUserItem;
